<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<h1>Copyright Information ©</h1>
<p><strong>Tom Drennen 2025</strong></p><br/>
<p>All rights reserved. No part of this publication may be reproduced, distributed, or transmitted in any form or by any means, including photocopying, recording, or other electronic or mechanical methods, without the prior written permission of the publisher, except in the case of brief quotations embodied in critical reviews and certain other non-commercial uses permitted by copyright law. For permission requests, write to the publisher.</p><br/>
<p>Any person who commits any unauthorized act in relation to this publication may be liable to criminal prosecution and civil claims for damages.</p><br/>
<p>This is a work of fiction. Names, characters, businesses, places, events, locales, and incidents are either the products of the author’s imagination or used in a fictitious manner. Any resemblance to actual persons, living or dead, or actual events is purely coincidental.</p><br/>
<p><strong>Ordering Information</strong></p>
<p>Quantity sales: Special discounts are available on quantity purchases by corporations, associations, and others. For details, contact the publisher at the address below.</p><br/>
<p><strong>Publisher’s Cataloging-in-Publication data</strong></p>
<p>Drennen, Tom</p>
<p>Guardian Guerrillas</p><br/>
<p>ISBN 9798889100546 (Paperback)</p>
<p>ISBN 9798889100553 (ePub e-book)</p><br/>
<p>Library of Congress Control Number: 2024911533</p><br/>
<p>www.austinmacauley.com/us</p><br/>
<p>First Published 2025</p>
<p>Austin Macauley Publishers LLC</p>
<p>40 Wall Street, 33rd Floor, Suite 3302</p>
<p>New York, NY 10005 USA</p><br/>
<p>mailto:mail-usa@austinmacauley.com</p>
<p>+1 (646) 5125767</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?6c59af54